import { Autocomplete, TextField, Typography } from '@mui/material';
import { memo, RefObject, SyntheticEvent } from 'react';

interface CityProps {
  name?: string;
  size?: 'small' | 'medium';
  disabled?: boolean;
  value?: string | null;
  options?: string[];
  onChange?: (event: SyntheticEvent<Element, Event>, newValue: string | null, name?: string) => void;
  inputRef?: RefObject<HTMLInputElement>;
  error?: boolean;
  errormsg?: string;
  required?: boolean;
  label?: string;
}

const City = ({ name, label = '', size, disabled, value, options = [], onChange, inputRef, error, errormsg, required }: CityProps) => {
  const uniqueId = name
    ? `city-${name.replace(/[^a-zA-Z0-9]/g, '-')}-${Math.random().toString(36).substr(2, 9)}`
    : `city-${Math.random().toString(36).substr(2, 9)}`;
  return (
    <>
      <input
        type="text"
        name={`dummy-${uniqueId}`}
        autoComplete="off"
        style={{ position: 'absolute', left: '-9999px', opacity: 0, pointerEvents: 'none', height: 0, width: 0 }}
        tabIndex={-1}
        readOnly
      />
      <Autocomplete
        openOnFocus
        freeSolo
        size={size}
        disabled={disabled}
        options={options}
        value={value}
        onChange={(event, newValue) => {
          if (onChange) {
            onChange(event, newValue, name);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            name={name}
            inputRef={inputRef}
            required={required}
            autoComplete="new-password"
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password',
              autoCapitalize: 'off',
              autoCorrect: 'off',
              spellCheck: 'false',
              'data-form-type': 'other',
              'data-lpignore': 'true',
            }}
            InputProps={{
              ...params.InputProps,
              autoComplete: 'new-password',
            }}
            InputLabelProps={{
              ...params.InputLabelProps,
              ...(required && {
                sx: {
                  ...(params.InputLabelProps as { sx?: object })?.sx,
                  '& .MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '20px',
                    fontWeight: 'bold',
                  },
                },
              }),
            }}
            error={error}
            onChange={(event) => {
              if (onChange) {
                const raw = event.target.value;
                // Capitalize first letter of each word, similar to legal name field
                const capitalized = raw ? raw.replace(/\b\w/g, (l) => l.toUpperCase()) : '';
                onChange(event as SyntheticEvent<Element, Event>, capitalized, name);
              }
            }}
          />
        )}
      />
      <Typography
        sx={{
          marginTop: '2px',
          marginLeft: '10px',
          marginBottom: '0px',
          fontSize: '11px',
          color: 'danger.main',
          // minHeight: "16px",
        }}
      >
        {errormsg ? errormsg : ''}
      </Typography>
    </>
  );
};

export default memo(City);
